export const name = 'gzL10nInterpolationService';

/**
 * An angular-translate interpolation service for supporting a simplified Java MessageFormat
 * syntax.  By Default, angular-translate interpolates parameters like angular with syntax {{token}}.
 * Java syntax uses placeholders like {0}, {1}, etc.
 *
 * Angular-translate by default expects an object for interpolation parameters.  This service instead
 * expects an array of parameters, similar to Java syntax.
 *
 * @example
 *  <div translate="pb.app.THOUSANDS_OF_IMPRESSIONS" translate-values="[{{vm.currentImpressionCount()}}]"></div>
 *  <div translate="app.catalog.MULTIPLE_VALUES_REQUIRED" translate-values="['a','b','c','d']"></div>
 *
 * Dates are supported and localized using moment.js.  Date FormatStyle is not currently supported and defaults to
 * the localized moment.js format 'LL'.
 *
 * This currently does not support any MessageFormat FormatTypes besides 'date' and any FormatStyle parameters.
 *
 * @see https://github.com/angular-translate/angular-translate/issues/924
 * @see http://docs.oracle.com/javase/7/docs/api/java/text/MessageFormat.html
 * @returns {{setLocale: setLocale, getInterpolationIdentifier: getInterpolationIdentifier, interpolate: interpolate}}
 */
export default function gzL10nInterpolationService(moment) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const messageArgIndexGroup = '(\\d+)';
  const messageFormatTypeOptionalGroup = '(?:,(\\w+))?';
  const messageFormatRegExp = new RegExp('\\{' + messageArgIndexGroup + messageFormatTypeOptionalGroup + '\\}', 'g');

  let service = {
    setLocale: setLocale,
    getInterpolationIdentifier: getInterpolationIdentifier,
    interpolate: interpolate,
  };

  return service;

  /////////////////

  function setLocale(locale) {
  }

  function getInterpolationIdentifier() {
    return 'java';
  }

  function interpolate(str, interpolateParams) {
    if(!interpolateParams || _.isEmpty(interpolateParams)) {
      return str;
    }

    // Looks like angular-translate requires an object with parameters or an array.
    // This convenience doesn't currently work.
    // Wrap a single object into an array for ease of using a single element
    //if(!Array.isArray(interpolateParams)) {
    //  interpolateParams = [interpolateParams];
    //}

    // Adapted from http://stackoverflow.com/a/1353411/277307
    return str.replace(messageFormatRegExp, function(match, argumentIndex, formatType) {
      let paramValue = interpolateParams[argumentIndex];

      switch(formatType) {
        case 'date':
          return formatDate(paramValue);
        case 'time':
          return formatTime(paramValue);
        default:
          return paramValue;
      }
    });
  }

  function formatDate(paramValue) {
    return moment(paramValue).format('LL');
  }

  function formatTime(paramValue) {
    return moment(paramValue).format('LT');
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/l10n/l10n.interpolation.service.js